module.exports = __webpack_public_path__ + "img/hu3.2100d1e1.jpg";